import React from 'react';
import { useListDetailViewContext } from 'Components/ComponentLibrary/Organisms/ListDetailView/Context';
import DataContainer from 'Components/UI/DataContainer';
import ListPicker from 'Organisms/ListDetailView/List/ListPicker';

const ListContainer = () => {
  const {
    listCollection,
    listIsInitializing,
    listLoadingError,
  } = useListDetailViewContext();

  return (
    <DataContainer
      component={ListPicker}
      loading={listIsInitializing}
      loadingError={listLoadingError}
      componentProps={{
        collection: listCollection,
      }}
    />
  );
};

ListContainer.propTypes = {
};

export default ListContainer;
